import { getStoryblokSdk } from '../../../api/api';

interface GetArticlesByFiltersProps {
  perPage?: number;
  page: number;
  filters: {
    author?: string;
    category?: string;
  };
  draftMode: boolean;
}

export const getArticlesByFilters = async ({
  perPage,
  page,
  filters,
  draftMode,
}: GetArticlesByFiltersProps) => {
  const { getArticleNodes } = getStoryblokSdk({ draftMode });

  const articlesPerPage = 6;

  const resolvedPerPage = perPage ? perPage : articlesPerPage;

  const { total, data: articles } = await getArticleNodes({
    perPage: resolvedPerPage,
    page,
    relations: '',
    sortBy: 'first_published_at:desc',
    excludingFields:
      'body,afterBody,beforeBody,customPreHeader,customHeader,seo,author,categories,category,advancedSeo,disablePreHeader',
    filterQuery: {
      component: {
        in: 'article',
      },
      ...(filters.category && {
        categories: {
          any_in_array: filters.category,
        },
      }),
      ...(filters?.author && { author: { in: filters.author } }),
    },
    startsWith: 'blog',
  });

  return { total, articles, articlesPerPage };
};
